/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  PaginatedRunEventsDTO,
  PaginatedRunsDTO,
  PlatformSyncStatusDTO,
  SyncRunResultDTO,
  ToggleProductPageSyncEnabledDTO
} from "../models";
import {
  PaginatedRunEventsDTOFromJSON,
  PaginatedRunEventsDTOToJSON,
  PaginatedRunsDTOFromJSON,
  PaginatedRunsDTOToJSON,
  PlatformSyncStatusDTOFromJSON,
  PlatformSyncStatusDTOToJSON,
  SyncRunResultDTOFromJSON,
  SyncRunResultDTOToJSON,
  ToggleProductPageSyncEnabledDTOFromJSON,
  ToggleProductPageSyncEnabledDTOToJSON
} from "../models";

export interface GetRunByIdRequest {
  runId: number;
}

export interface GetRunEventsRequest {
  runId: number;
  limit?: number;
  offset?: number;
  action?: GetRunEventsActionEnum;
}

export interface ListRunsRequest {
  limit?: number;
  offset?: number;
  status?: ListRunsStatusEnum;
  platformId?: number;
}

export interface RunSyncRequest {
  platformId?: number;
}

export interface SetPlatformEnabledRequest {
  platformId: number;
  toggleProductPageSyncEnabledDTO: ToggleProductPageSyncEnabledDTO;
}

/**
 *
 */
export class ProductPageSyncApi extends runtime.BaseAPI {
  /**
   */
  async getPlatformStatusesRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<PlatformSyncStatusDTO>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/productPageSync/platforms`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PlatformSyncStatusDTOFromJSON));
  }

  /**
   */
  async getPlatformStatuses(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<PlatformSyncStatusDTO>> {
    const response = await this.getPlatformStatusesRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async getRunByIdRaw(
    requestParameters: GetRunByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<SyncRunResultDTO>> {
    if (requestParameters.runId === null || requestParameters.runId === undefined) {
      throw new runtime.RequiredError(
        "runId",
        "Required parameter requestParameters.runId was null or undefined when calling getRunById."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/productPageSync/runs/{runId}`.replace(
          `{${"runId"}}`,
          encodeURIComponent(String(requestParameters.runId))
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => SyncRunResultDTOFromJSON(jsonValue));
  }

  /**
   */
  async getRunById(
    requestParameters: GetRunByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<SyncRunResultDTO> {
    const response = await this.getRunByIdRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async getRunEventsRaw(
    requestParameters: GetRunEventsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedRunEventsDTO>> {
    if (requestParameters.runId === null || requestParameters.runId === undefined) {
      throw new runtime.RequiredError(
        "runId",
        "Required parameter requestParameters.runId was null or undefined when calling getRunEvents."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.limit !== undefined) {
      queryParameters["limit"] = requestParameters.limit;
    }

    if (requestParameters.offset !== undefined) {
      queryParameters["offset"] = requestParameters.offset;
    }

    if (requestParameters.action !== undefined) {
      queryParameters["action"] = requestParameters.action;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/productPageSync/runs/{runId}/events`.replace(
          `{${"runId"}}`,
          encodeURIComponent(String(requestParameters.runId))
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedRunEventsDTOFromJSON(jsonValue));
  }

  /**
   */
  async getRunEvents(
    requestParameters: GetRunEventsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedRunEventsDTO> {
    const response = await this.getRunEventsRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async listRunsRaw(
    requestParameters: ListRunsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedRunsDTO>> {
    const queryParameters: any = {};

    if (requestParameters.limit !== undefined) {
      queryParameters["limit"] = requestParameters.limit;
    }

    if (requestParameters.offset !== undefined) {
      queryParameters["offset"] = requestParameters.offset;
    }

    if (requestParameters.status !== undefined) {
      queryParameters["status"] = requestParameters.status;
    }

    if (requestParameters.platformId !== undefined) {
      queryParameters["platformId"] = requestParameters.platformId;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/productPageSync/runs`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedRunsDTOFromJSON(jsonValue));
  }

  /**
   */
  async listRuns(
    requestParameters: ListRunsRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedRunsDTO> {
    const response = await this.listRunsRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async runSyncRaw(
    requestParameters: RunSyncRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<SyncRunResultDTO>>> {
    const queryParameters: any = {};

    if (requestParameters.platformId !== undefined) {
      queryParameters["platformId"] = requestParameters.platformId;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/productPageSync/run`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SyncRunResultDTOFromJSON));
  }

  /**
   */
  async runSync(
    requestParameters: RunSyncRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<SyncRunResultDTO>> {
    const response = await this.runSyncRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async setPlatformEnabledRaw(
    requestParameters: SetPlatformEnabledRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PlatformSyncStatusDTO>> {
    if (requestParameters.platformId === null || requestParameters.platformId === undefined) {
      throw new runtime.RequiredError(
        "platformId",
        "Required parameter requestParameters.platformId was null or undefined when calling setPlatformEnabled."
      );
    }

    if (
      requestParameters.toggleProductPageSyncEnabledDTO === null ||
      requestParameters.toggleProductPageSyncEnabledDTO === undefined
    ) {
      throw new runtime.RequiredError(
        "toggleProductPageSyncEnabledDTO",
        "Required parameter requestParameters.toggleProductPageSyncEnabledDTO was null or undefined when calling setPlatformEnabled."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/productPageSync/platforms/{platformId}/enabled`.replace(
          `{${"platformId"}}`,
          encodeURIComponent(String(requestParameters.platformId))
        ),
        method: "PATCH",
        headers: headerParameters,
        query: queryParameters,
        body: ToggleProductPageSyncEnabledDTOToJSON(requestParameters.toggleProductPageSyncEnabledDTO)
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => PlatformSyncStatusDTOFromJSON(jsonValue));
  }

  /**
   */
  async setPlatformEnabled(
    requestParameters: SetPlatformEnabledRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PlatformSyncStatusDTO> {
    const response = await this.setPlatformEnabledRaw(requestParameters, initOverrides);
    return await response.value();
  }
}

/**
 * @export
 */
export const GetRunEventsActionEnum = {
  SET_ONLINE: "SET_ONLINE",
  SET_OFFLINE: "SET_OFFLINE",
  START_GRACE: "START_GRACE",
  RESET_GRACE: "RESET_GRACE",
  CREATE: "CREATE",
  DELETE: "DELETE",
  ERROR: "ERROR",
  RECONCILE: "RECONCILE"
} as const;
export type GetRunEventsActionEnum = typeof GetRunEventsActionEnum[keyof typeof GetRunEventsActionEnum];
/**
 * @export
 */
export const ListRunsStatusEnum = {
  RUNNING: "RUNNING",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED"
} as const;
export type ListRunsStatusEnum = typeof ListRunsStatusEnum[keyof typeof ListRunsStatusEnum];
